import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import {
  Button,
  ButtonSizeEnum,
  ButtonVariantEnum,
  ErrorRoundedIcon,
  Modal,
  ModalBody,
  ModalHeader,
  ModalSizeEnum,
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import styles from './GenericErrorModal.module.scss';

type GenericErrorModalProps = {
  onDismiss: () => void;
};

const GenericErrorModal: React.FC<GenericErrorModalProps> = ({ onDismiss }) => {
  const t = useTranslations();

  return (
    <Modal
      open
      onClose={onDismiss}
      size={ModalSizeEnum.MEDIUM}
      className={styles.modal}
      data-testid="generic-error-modal"
    >
      <ModalHeader handleClose={onDismiss} />
      <ModalBody
        className={styles.body}
        data-testid="generic-error-modal-body"
      >
        <div className={styles.content}>
          <div className={styles.heading}>
            <ErrorRoundedIcon
              className={styles.icon}
              size={20}
            />
            <Typography
              component={TypographyComponentEnum.SPAN}
              variant={TypographyVariant.title.medium}
              className={styles.header}
            >
              {t('error_has_occurred')}
            </Typography>
          </div>
          <Typography
            component={TypographyComponentEnum.P}
            variant={TypographyVariant.body.medium}
            className={styles.message}
          >
            {t('generic_error_message')}
          </Typography>
          <Button
            data-testid="generic-error-modal-got-it"
            onClick={onDismiss}
            size={ButtonSizeEnum.LARGE}
            variant={ButtonVariantEnum.PRIMARY}
          >
            {t('got_it')}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default GenericErrorModal;
